<template>
  <vxe-modal v-model="visible" :title="$t('business.label.item')" type="confirm" width="75%" @cancel="cancel" @confirm="confirm">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"/>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.name.length > 10" :key="row.id" :title="row.name">
          <a-tag :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">{{`${row.name.slice(0, 10)}...`}}</a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" color="blue" @close="() => closeTag(row)">{{row.name}}</a-tag>
      </template>
    </template>
    <vxe-card>
      <template #title>
        <vxe-select v-model="query['owner.id']" :options="owners" placeholder="business.label.owner" @change="refresh"/>
        <vxe-input v-model="query.no" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.mnemonicCode" placeholder="business.label.mnemonicCode" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        @checkbox-all="({checked})=>checkAll(checked)"
        @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="no" title="business.label.itemNo" width="80"/>
        <vxe-column field="name" title="business.label.itemName"/>
        <vxe-column field="itemType.name" title="business.label.itemType"/>
        <vxe-column :formatter="({row})=>getStrings(row.owners,'name')" field="owners" title="business.label.owner"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:saleClassifications}" field="saleClassification" title="business.label.saleClassification"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:storageEnvironments}" field="storageEnvironment" title="business.label.storageEnvironment"/>
        <vxe-column field="mnemonicCode" title="business.label.mnemonicCode"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="importation" title="business.label.importation" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="valuable" title="business.label.valuable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supervised" title="business.label.supervised" width="70"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>
<script>
import { findAll } from '@/api/Api'
import { getEnums, getOptions, getStrings } from '@/utils/util'

export default {
  name: 'ItemModal',
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { 'owner.id': '', no: '', name: '', mnemonicCode: '' },
      args: null,
      selectedRows: [],
      owners: [],
      saleClassifications: [],
      storageEnvironments: [],
      record: undefined,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getEnums('SaleClassification')
    }).then(result => {
      this.saleClassifications = result
      return getEnums('StorageEnvironment')
    }).then(result => {
      this.storageEnvironments = result
    })
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    }
  },
  methods: {
    getStrings,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    init(args) {
      this.query = { 'owner.id': '', no: '', name: '', mnemonicCode: '' }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    fetch() {
      this.loading = true
      findAll('itemFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { 'owner.id': '', no: '', name: '', mnemonicCode: '' }
      Object.assign(this.query, this.args)
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>